import { SVGProps } from "react";
import { motion } from "framer-motion";

const Trash = (props: SVGProps<SVGSVGElement> & { animate?: boolean }) => (
  <motion.svg
    initial={{ opacity: 0 }}
    animate={props.animate ? { opacity: 1 } : {}}
    transition={{ duration: 0.1 }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    onClick={props.onClick}
  >
    <path
      d="M19.3898 7.5879C19.3734 7.5879 19.3488 7.5879 19.3241 7.5879C14.983 7.14417 10.6501 6.97673 6.35815 7.42045L4.68406 7.5879C4.3394 7.62138 4.03576 7.37022 4.00294 7.01859C3.97011 6.66696 4.2163 6.36557 4.55276 6.33208L6.22685 6.16464C10.5926 5.71254 15.0158 5.88836 19.4472 6.33208C19.7837 6.36557 20.0299 6.67534 19.9971 7.01859C19.9724 7.34511 19.7016 7.5879 19.3898 7.5879Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M9.13197 6.74233C9.09914 6.74233 9.06632 6.74233 9.02528 6.73396C8.69703 6.67536 8.46725 6.34884 8.5247 6.01396L8.70524 4.91721C8.83654 4.11349 9.01708 3 10.9292 3H13.0792C14.9995 3 15.18 4.15535 15.3031 4.92559L15.4837 6.01396C15.5411 6.35722 15.3113 6.68373 14.9831 6.73396C14.6466 6.79257 14.3266 6.55815 14.2773 6.22326L14.0968 5.13489C13.9819 4.40651 13.9573 4.26419 13.0874 4.26419H10.9374C10.0675 4.26419 10.0511 4.3814 9.92798 5.12652L9.73923 6.21489C9.69 6.52466 9.42739 6.74233 9.13197 6.74233Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M14.6383 21H9.36986C6.50585 21 6.39096 19.3842 6.30069 18.0781L5.76728 9.64742C5.74266 9.30416 6.00527 9.00276 6.34172 8.97765C6.68639 8.9609 6.97361 9.22044 6.99823 9.5637L7.53164 17.9944C7.62191 19.267 7.65474 19.7442 9.36986 19.7442H14.6383C16.3616 19.7442 16.3945 19.267 16.4765 17.9944L17.0099 9.5637C17.0346 9.22044 17.33 8.9609 17.6665 8.97765C18.0029 9.00276 18.2655 9.29579 18.2409 9.64742L17.7075 18.0781C17.6172 19.3842 17.5023 21 14.6383 21Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M13.3665 16.3954H10.6338C10.2973 16.3954 10.0183 16.1107 10.0183 15.7675C10.0183 15.4242 10.2973 15.1396 10.6338 15.1396H13.3665C13.7029 15.1396 13.982 15.4242 13.982 15.7675C13.982 16.1107 13.7029 16.3954 13.3665 16.3954Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M14.0558 13.0465H9.95259C9.61613 13.0465 9.33712 12.7619 9.33712 12.4186C9.33712 12.0754 9.61613 11.7907 9.95259 11.7907H14.0558C14.3922 11.7907 14.6712 12.0754 14.6712 12.4186C14.6712 12.7619 14.3922 13.0465 14.0558 13.0465Z"
      fill={props.fill || "#1A1C1F"}
    />
  </motion.svg>
);
export default Trash;
